import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { TruckDriverItemDelete, TruckDriversInitialState, TruckDriversLoad } from './truck-drivers.actions';
import { TruckDriversState, TruckDriversStateModel } from './truck-drivers.state';
import { TruckDriverBrief, TruckDriversSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class TruckDriversFacade {
  listDto$: Observable<TruckDriversStateModel> = this.store.select(TruckDriversState.getState);
  loaded$: Observable<boolean> = this.store.select(TruckDriversState.getLoaded);
  items$: Observable<TruckDriverBrief[]> = this.store.select(TruckDriversState.getItems);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.TruckDrivers)
      .subscribe((searchCriteria: TruckDriversSearchCriteria) => {
        this.store.dispatch(new TruckDriversLoad(searchCriteria));
      });
  }

  deleteTruckDriver(
    hubId: number,
    frequentDriverIds: number[],
    truckIds: number[],
    tourExecutionIds: number[],
    dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>,
  ): void {
    this.store.dispatch(new TruckDriverItemDelete({ dialog, hubId, frequentDriverIds, truckIds, tourExecutionIds }));
  }

  setInitialState(): void {
    this.store.dispatch(new TruckDriversInitialState());
  }
}
